import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Entity, Slice } from '@shapeable/types';
import { breakpoints, theme, ColorTokens } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { HumantixEmbed, HumantixEmbedProps } from '../elements/humantix-embed';

const cls = classNames('slice-humantix-embed');

// -------- Types -------->

// -------- Props -------->

export type SliceHumantixEmbedProps = Classable & HasChildren & HumantixEmbedProps & { 
  entity?: Slice;
};

export const SliceHumantixEmbedDefaultProps: Omit<SliceHumantixEmbedProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});


// -------- Components -------->

const My = {
  Container: styled(HumantixEmbed)<ContainerProps>`${ContainerStyles}`,
};

export const SliceHumantixEmbed: Shapeable.FC<SliceHumantixEmbedProps> = (props) => {
  const { className, children, entity, collection } = props;
  
  return (
    <My.Container collection={collection} className={cls.name(className)} />
  )
};

SliceHumantixEmbed.defaultProps = SliceHumantixEmbedDefaultProps;
SliceHumantixEmbed.cls = cls;